import {API} from "@/Composables/api";

const getNotifications = async (params = {}) => {
    return API.get(route("notifications.index"), params);
};

const markNotificationAsRead = async (notification: string, params = {}) => {
    return API.post(route("notifications.mark-read", notification), params);
};

const markAllNotificationAsRead = async () => {
    return API.post(route("notifications.all-read"));
};

export {getNotifications, markNotificationAsRead, markAllNotificationAsRead};
